module.exports = __webpack_public_path__ + "img/delivery-date.f87eeb23.svg";